"use client";

import { useAuth } from "@/lib/auth-context";
import DocumentSetSidebar from "@/components/document-set-sidebar";

/**
 * Main content area with optional left document-set sidebar when authenticated.
 */
export default function AppShell({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const showSidebar = Boolean(user && !user.mustChangePassword);

  return (
    <div className="flex flex-1 pt-[50px] pb-[50px] min-h-0">
      {showSidebar && <DocumentSetSidebar />}
      <main
        className={
          "flex-1 min-w-0 overflow-x-hidden" + (showSidebar ? " ml-56" : "")
        }
      >
        {children}
      </main>
    </div>
  );
}
